export default __webpack_public_path__ + "static/sparkline-d4b6e8fb0066f2937780b8c831f79b21.jpg";